<template>
  <button
    class="inline cursor-pointer px-1 rounded-sm border"
    :class="{
      'text-red-600 hover:text-red-900 bg-red-100 hover:bg-red-200 border-red-600': !disabled,
      'text-gray-400 cursor-not-allowed bg-gray-50 border-gray-300': disabled,
    }"
    @click="onClick"
  >
    Supprimer
  </button>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import useApi from '@/hooks/useApi'

const props = defineProps({
  disabled: Boolean,
  doc_number: [String, Number],
  apiType: String,
  numberPrefix: {
    type: String,
    required: true,
    default: 'FA',
  },
})
const emit = defineEmits(['removed'])
const api = useApi()

const onClick = () => {
  if (props.disabled) {
    // alert(`Le document ${props.numberPrefix}-${props.doc_number} ne peut plus etre supprimer. (24h)`)
    return
  }
  const ok = confirm(`Etes vous sur de vouloir supprimer le document ${props.numberPrefix}-${props.doc_number}.`)
  if (ok) {
    api[props.apiType].remove({ doc_number: props.doc_number }).then(res => {
      emit('removed', res)
    })
  }
}
</script>

<style></style>
